import { AdminCloneJobBodyDto } from 'app/API';

export const getClonePayloadTranscriptUnlockType = (
  useSourceJobData: boolean,
  targetTranscriptUnlockType: AdminCloneJobBodyDto['transcriptUnlockType'],
): AdminCloneJobBodyDto['transcriptUnlockType'] | undefined =>
  useSourceJobData ? undefined : targetTranscriptUnlockType;
